import { getSpareIssueDetailsAPICall, getSpareIssueDetailsByJC } from "../services/apiCalls";
import { EKeys } from "../services/entity";
export var getGeneralDetails = function (feild, data) {
    var _data$GivenName, _data$FamilyName;
    switch (feild) {
        case EKeys.Customer:
            return data && (data !== null && data !== void 0 && data.GivenName || data !== null && data !== void 0 && data.FamilyName) ? "".concat((_data$GivenName = data === null || data === void 0 ? void 0 : data.GivenName) !== null && _data$GivenName !== void 0 ? _data$GivenName : '', " ").concat((_data$FamilyName = data === null || data === void 0 ? void 0 : data.FamilyName) !== null && _data$FamilyName !== void 0 ? _data$FamilyName : '') : '';
        case EKeys.ServiceAdvisor:
            return data && data !== null && data !== void 0 && data.ServiceAdvisorName ? data && (data === null || data === void 0 ? void 0 : data.ServiceAdvisorName) : '';
        case EKeys.Technician:
            return data !== null && data !== void 0 && data.TechnicianName ? "".concat(data === null || data === void 0 ? void 0 : data.TechnicianName) : '';
        case EKeys.FloorSupervisor:
            return data !== null && data !== void 0 && data.FloorSupervisorName ? data === null || data === void 0 ? void 0 : data.FloorSupervisorName : '';
        case EKeys.Vehicle:
            return data !== null && data !== void 0 && data.ProductName ? "".concat(data === null || data === void 0 ? void 0 : data.ProductName) : '';
        default:
            break;
    }
};
export var getSpareIssueDetails = function (id, tenantId, mode) {
    if (mode === "create")
        return function (params) { return getSpareIssueDetailsByJC({
            request: {
                JobCardId: id,
                TenantId: tenantId
            }
        }); };
    if (mode == "edit")
        return function (params) { return getSpareIssueDetailsAPICall({
            request: {
                id: id
            }
        }); };
    return undefined;
};
export var getSearchDisable = function (selectedOption, inputValue) {
    var isDisabled = false;
    switch (selectedOption) {
        case "All":
            isDisabled = inputValue.length >= 8;
            break;
        case "JobCardNo":
            isDisabled = inputValue.length >= 3;
            break;
        case "VinNo":
            isDisabled = inputValue.length >= 16;
            break;
        case "RegistrationNo":
            isDisabled = inputValue.length >= 8;
            break;
        default:
            isDisabled = false;
    }
    return !isDisabled;
};
